import { render, staticRenderFns } from "./EntryLink.vue?vue&type=template&id=1542cfb2&"
import script from "./EntryLink.vue?vue&type=script&lang=js&"
export * from "./EntryLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports